// extracted by mini-css-extract-plugin
export var container = "Dashboard-module--container--pik-k";
export var content = "Dashboard-module--content--9sHX1";
export var dashboardColOneHalf = "Dashboard-module--dashboardColOneHalf--UmBJa";
export var dashboardColOneThird = "Dashboard-module--dashboardColOneThird--o0NDs";
export var dashboardColTwoThird = "Dashboard-module--dashboardColTwoThird--rLCFs";
export var dashboardRow = "Dashboard-module--dashboardRow--zULq4";
export var dashboardTitle = "Dashboard-module--dashboardTitle--rsGEE";
export var growyzeIcon = "Dashboard-module--growyzeIcon--XAIzO";
export var rocketIcon = "Dashboard-module--rocketIcon--Kpz8v";